var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { cx, css as emotionCss } from 'emotion';
import { DroppedItem as Component } from './DragNDrop.styled';
import { getAutomation, getDebug } from '@citrus/runtime';
import { isNotNullOrEmpty } from '@pcty/utils';
import '../css/citron.css';
import '../css/dragulaCitron.css';
var VERSION = 'unknown';
/** DISPLAY NAME: &lt;DragNDrop.DroppedItem&gt; */
var DragNDropDroppedItem = React.forwardRef(function (_a, ref) {
    var _b;
    var automationId = _a.automationId, children = _a.children, className = _a.className, css = _a.css, disabled = _a.disabled, id = _a.id, _c = _a.__TYPE, TYPE = _c === void 0 ? 'DragNDropDroppedItem' : _c, other = __rest(_a, ["automationId", "children", "className", "css", "disabled", "id", "__TYPE"]);
    var _css = ['citron-draggable-item', 'citron-draggable-item-content', disabled ? 'citron-disabled' : '']
        .filter(function (x) { return x.length > 0; })
        .join(' ');
    var classes = cx(_css, (_b = {},
        _b[emotionCss(css)] = isNotNullOrEmpty(css),
        _b), className || '');
    return (React.createElement(Component, __assign({ className: classes, id: id, ref: ref, unselectable: "on" }, other, getAutomation(automationId), getDebug(sessionStorage.getItem('citrus-debug') === 'true', TYPE, VERSION)), children));
});
DragNDropDroppedItem.defaultProps = {
    __TYPE: 'DragNDropDroppedItem',
};
export default DragNDropDroppedItem;
